import jpegFile from "@/src/assets/images/neutral/file_types/jpeg_file.svg";
import jpgFile from "@/src/assets/images/neutral/file_types/jpg_file.svg";
import pngFile from "@/src/assets/images/neutral/file_types/png_file.svg";
import pdfFile from "@/src/assets/images/neutral/file_types/pdf_file.svg";
import docFile from "@/src/assets/images/neutral/file_types/doc_file.svg";
import videoFile from "@/src/assets/images/neutral/file_types/video_file.svg";
import audioFile from "@/src/assets/images/neutral/file_types/audio_file.svg";
import imageFile from "@/src/assets/images/neutral/file_types/image_file.svg";
import csvFile from "@/src/assets/images/neutral/file_types/csv_file.svg";
import pptFile from "@/src/assets/images/neutral/file_types/ppt_file.svg";
import defaultFile from "@/src/assets/images/neutral/file_types/default_file.svg";

export default {
  thumbnail: {
    jpeg: jpegFile,
    jpg: jpgFile,
    png: pngFile,
    pdf: pdfFile,
    doc: docFile,
    video: videoFile,
    audio: audioFile,
    image: imageFile,
    csv: csvFile,
    ppt: pptFile,
    default: defaultFile,
  },
};
